import "../plugins/slickPlugin"

export default function initM87() {
    $(function () {
        $(".platforms-wrap .carousel").each(function () {
            const ref = $(this)
            setTimeout(() => {
                ref.find(".sync-carousel").slick({
                    arrows: false,
                    autoplay: false,
                    // waitForAnimate: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    asNavFor: ref.find('.slider-nav'),
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
                ref.find('.slider-nav').slick({
                    arrows: false,
                    autoplay: false,
                    // waitForAnimate: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: ref.find(".sync-carousel"),
                    dots: true,
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: true,
                                prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 6.2 11" viewBox="0 0 6.2 11"><path d="M4.8.2.1 5c-.3.3-.3.7 0 1l4.8 4.8c.3.3.8.3 1.1 0 .3-.3.3-.8 0-1.1L1.8 5.5l4.1-4.2c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0z"/></svg></button>',
                                nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.2 11" style="enable-background:new 0 0 6.2 11" xml:space="preserve"><path d="M1.3.2 6 5c.3.3.3.7 0 1l-4.8 4.8c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l4.2-4.2L.2 1.3C-.1 1-.1.5.2.2c.3-.3.8-.3 1.1 0z" /></svg></button>',
                            }
                        }
                    ]
                });
            }, 250);
        })
    })
}